import { FC } from "react";
import { OutreachExportFormatType } from "@app/network-outreach/export/enumerations";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";

interface SelectFormatFilterProps {
  testIdPrefix: string; // Used for the testId
  onOutputFormatChange: (exportFormat: OutreachExportFormatType) => void;
  outputFormat: OutreachExportFormatType;
}

const SelectFormatFilter: FC<SelectFormatFilterProps> = (props: SelectFormatFilterProps) => {
  const outputFormats: Array<{ key: OutreachExportFormatType, value: string }> = [
    { key: OutreachExportFormatType.CSV, value: "Comma-Delimited Text File (.csv)" },
    { key: OutreachExportFormatType.Tab, value: "Tab-Delimited Text File (.txt)" },
    { key: OutreachExportFormatType.Pipe, value: "Bar-Delimited Text File (.txt)" }
  ];

  return (
    <>
      <p className="lead mb0 demibold">Format Filter</p>
      <div className="form-group row">
        <div className="col-lg-12">
          <QESSelect
            containerClassName="mb-0"
            label="Please select the output format:"
            onChange={(e) => props.onOutputFormatChange(e.target.value as OutreachExportFormatType)}
            testId={`outreach-export-${props.testIdPrefix}__format-select`}
            value={props.outputFormat}
          >
            {
              outputFormats.map(({ key, value }) => (
                <option key={key} value={key}>{value}</option>
              ))}
          </QESSelect>
        </div>
      </div>
    </>
  );
}

export default SelectFormatFilter;
